import { v4 as uuid } from 'uuid';

export function createId() {
  // start id with a letter to avoid some footguns
  // e.g. `document.querySelector('#1')` throws a "not a valid selector" error
  // even though something like `document.querySelector('[id="1"]')` would work
  return `a-${uuid()}`;
}
